<div class="row">
  <div class="col-lg-10">
    <h1>Register Application</h1>
    <br>
  </div>
</div>
<div class="row">
  <div class="col-sm-11">
    <form role="form" #registrationForm="ngForm" (ngSubmit)="registerApplication();">
      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Application
          Name</label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.applicationName" name="applicationName" type="text"
              class="form-control field" id="applicationName" #applicationName="ngModel"
              [ngClass]="applicationName.errors  ? 'has-danger':'has-success'" required>
          </div>
          <div *ngIf="applicationName.errors && (applicationName.dirty || applicationName.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!applicationName.errors.required">
              <span class="Semi" style="color: red; font-weight: bold">Application
                Name is required</span>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Success
          API URL<i style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
            title="{{successApiUrlTitle}}" class="fa fa-question" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.successUrl" name="successUrl" type="text" class="form-control field"
              id="successURL" #successURL="ngModel" [ngClass]="successURL.errors  ? 'has-danger':'has-success'"
              required>
          </div>
          <div *ngIf="successURL.errors && (successURL.dirty || successURL.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!successURL.errors.required">
              <span style="color: red; font-weight: bold">Application
                Success API URL is required</span>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Failure
          API URL<i title="{{failureApiUrlTitle}}"
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" class="fa fa-question"
            aria-hidden="true"></i>
        </label>
        <div class="row">

          <div class="col-sm-7">
            <input [(ngModel)]="application.failureUrl" name="failureUrl" type="text" class="form-control field"
              id="failureURL" #failureURL="ngModel" [ngClass]="failureURL.errors  ? 'has-danger':'has-success'"
              required>
          </div>
          <div *ngIf="failureURL.errors && (failureURL.dirty || failureURL.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!failureURL.errors.required">
              <span style="color: red; font-weight: bold">Application
                Failure API URL is required</span>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Cyberscore
          Threshold<i class="fa fa-question" aria-hidden="true" title="{{cyberscoreThresholdTitle}}"
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.cyberScoreThreshold" name="cyberScoreThreshold" type="number" min="0"
              max="800" (keyup)="validateCyberscoreThresholdRange()" class="form-control field" id="cyberScoreThreshold"
              #cyberScoreThreshold="ngModel" [ngClass]="cyberScoreThreshold.errors  ? 'has-danger':'has-success'"
              required>
          </div>
          <div *ngIf="cyberScoreThreshold.errors && (cyberScoreThreshold.dirty || cyberScoreThreshold.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!cyberScoreThreshold.errors.required">
              <span style="color: red; font-weight: bold"> Cyberscore
                Threshold is required</span>
            </div>
          </div>
          <div id="cyberScoreThresholdRangeErrorDiv" class="form-control-feedback error-text col-sm-5"
            [ngStyle]="{'display': 'none'}">
            <span style="color: red; font-weight: bold">Cyberscore threshold must be between 0 to 800</span>
          </div>
        </div>
      </fieldset>

      <!--
        Allow a user to login, even if no Entreda App is installed. Ask for the Grace period. Default is 0
      -->

      <fieldset class="form-group"  >
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Allow a grace period for users to login if no
          Unify Applet is installed on device?
          <i class="fa fa-question" title={{allowLoginGracePeriod}}
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input style="margin-left: 20%" type="radio" [(ngModel)]="byPassAppletCheck" name="byPassAppletCheck"
              [value]="true"> YES
            <input style="margin-left: 20%" type="radio" [(ngModel)]="byPassAppletCheck" name="byPassAppletCheck"
              [value]="false" [checked]> NO
          </div>
        </div>
      </fieldset>

      <fieldset class="collapsible" id="gracePeriodSelector" [hidden]="!byPassAppletCheck">
        <legend></legend>
        <fieldset class="form-group">
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col-sm-5 col-form-label" style="max-width: 58%">Group 1: </label>
            </div>
            <div class="col-sm-6">
              <select name="byPassValueDropownGroup1" id="byPassValueDropownGroup1" [(ngModel)]="byPassValueGroup1"
                [disabled]="!byPassAppletCheck" [required]="byPassAppletCheck" class="form-control"
                style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup1" [ngValue]="byPassVal">{{ byPassVal }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" style="max-width: 58%"
                for="emailGroup1">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'">
                <textarea [(ngModel)]="emailValueGroup1" class="form-control z-depth-1" name="emailGroup1"
                  id="emailGroup1" rows="3"
                  placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck" MultiEmailValidationDirective
                  #directiveRef="MultiEmailValidationDirective"> </textarea>
                <div *ngIf="directiveRef.error" class="form-control-feedback error-text col-sm-10">
                  <div [hidden]="!directiveRef.error">
                    <span style="color: red; font-weight: bold"> {{ directiveRef.errorMessage }} </span>
                  </div>
                </div>
              </section>
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'">
                <textarea [(ngModel)]="emailValueGroup1" class="form-control z-depth-1" name="emailGroup1"
                  id="emailGroup1" rows="3"
                  placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck"> </textarea>
              </section>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-group">
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col-sm-5 col-form-label" style="max-width: 58%">Group 2: </label>
            </div>
            <div class="col-sm-6">
              <select name="byPassValueDropown2" id="byPassValueDropown2" [(ngModel)]="byPassValueGroup2"
                [disabled]="!byPassAppletCheck" [required]="byPassAppletCheck" class="form-control"
                style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup2" [ngValue]="byPassVal">{{ byPassVal }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" style="max-width: 58%"
                for="emailGroup2">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7 has-error">
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'">
                <textarea class="form-control z-depth-1" [(ngModel)]="emailValueGroup2" name="emailGroup2"
                  id="emailGroup2" rows="3"
                  placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck" MultiEmailValidationDirective
                  #directiveRef1="MultiEmailValidationDirective"> </textarea>
                <div *ngIf="directiveRef1.error" class="form-control-feedback error-text col-sm-10">
                  <div [hidden]="!directiveRef1.error">
                    <span style="color: red; font-weight: bold"> {{ directiveRef1.errorMessage }} </span>
                  </div>
                </div>
              </section>
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'">
                <textarea class="form-control z-depth-1" [(ngModel)]="emailValueGroup2" name="emailGroup2"
                  id="emailGroup2" rows="3"
                  placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck"> </textarea>
              </section>
            </div>
          </div>
        </fieldset>

        <fieldset class="form-group" collapse>
          <legend></legend>
          <div class="row">
            <div class="col-sm-5">
              <label class="col-sm-5 col-form-label" style="max-width: 58%">Group 3: </label>
            </div>
            <div class="col-sm-6">
              <select name="byPassValueDropown3" id="byPassValueDropown3" [(ngModel)]="byPassValueGroup3"
                [disabled]="!byPassAppletCheck" [required]="byPassAppletCheck" class="form-control"
                style="max-width: 31.33%;">
                <option *ngFor="let byPassVal of byPassValueSetGroup3" [ngValue]="byPassVal">{{ byPassVal }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <label class="col-sm-7 col-form-label" style="max-width: 58%"
                for="emailGroup3">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}: </label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-7">
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'">
                <textarea class="form-control z-depth-1" [(ngModel)]="emailValueGroup3" name="emailGroup3"
                  id="emailGroup3" rows="3"
                  placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck" MultiEmailValidationDirective
                  #directiveRef2="MultiEmailValidationDirective"> </textarea>
                <div *ngIf="directiveRef2.error" class="form-control-feedback error-text col-sm-10">
                  <div [hidden]="!directiveRef2.error">
                    <span style="color: red; font-weight: bold"> {{ directiveRef2.errorMessage }} </span>
                  </div>
                </div>
              </section>
              <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'">
                <textarea *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'"
                  class="form-control z-depth-1" [(ngModel)]="emailValueGroup3" name="emailGroup3" id="emailGroup3"
                  rows="3" placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITH_S}} followed by a comma"
                  style="margin-left:13px;" [disabled]="!byPassAppletCheck"> </textarea>
              </section>
            </div>
          </div>
        </fieldset>
        <fieldset class="form-group" collapse>
          <div class="row">
            <div class="col-sm-5">
              <label class="col-sm-5 col-form-label">Group 4: </label>
            </div>
            <div class="col-sm-2">
              <input
                [(ngModel)]="group4DaysValue"
                name="group4Days"
                type="number"
                placeholder="No of Days"
                class="form-control field"
                id="group4Days"
                #group4Days="ngModel"
                (keyup)="validateGroup4Days()"
                [ngClass]="group4Days.errors ? 'has-danger' : 'has-success'"
                [required]="gracePeriodApplyToAllUsersCheck"
              />
            </div>
            <div
              *ngIf="group4Days.errors"
              class="form-control-feedback error-text col-sm-5"
              id="group4DaysRequiredDiv"
            >
              <div [hidden]="!group4Days.errors.required">
                <span style="color: red; font-weight: bold">Required</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div  class="col-sm-7 col-form-label" style="max-width: 58%">
              &nbsp;&nbsp;&nbsp;&nbsp;Apply to all users &nbsp;&nbsp;<input
              type="checkbox"
              [(ngModel)]="gracePeriodApplyToAllUsersCheck"
                name="gracePeriodApplyToAllUsers"
                id="gracePeriodApplyToAllUsers"
                #gracePeriodApplyToAllUsers
              [value]="false"
              (keyup)="validateGroup4Days()"
              />
              <i
                class="fa fa-question"
                title="{{ group4InfoText }}"
                style="
                padding: 5px;
                padding-left: 7px;
                padding-right: 7px;
                float: right;
              "
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </fieldset>

      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Allow selected users to bypass authentication
          service?<i style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
            title="{{allowBypassIpaddressTitle}}" class="fa fa-question" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input style="margin-left: 20%" type="radio" [(ngModel)]="application.appletcheckByPassIpaddress"
              name="bypassIpAddress" [value]="true"> YES
            <input style="margin-left: 20%" type="radio" [(ngModel)]="application.appletcheckByPassIpaddress"
              name="bypassIpAddress" [value]="false" [checked]> NO
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group" *ngIf="application.appletcheckByPassIpaddress">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Public IP addresses:<i
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" class="fa" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7 has-error">
            <textarea class="form-control z-depth-1" [(ngModel)]="ipAddressGroup" name="ipAddressGroupValid"
              id="ipAddressGroup" #ipAddressGroupValid="ngModel" rows="3"
              placeholder="Enter public IP addresses separated by a comma. For example: 148.64.99.217, 2001:0db8:85a3:0000:0000:8a2e:0370:7334"
              style="margin-left:13px;" [disabled]="bypassIpAddress" IpaddressValidation
              #ipDirectiveRef="ipaddressValidation"></textarea>
            <div *ngIf="ipDirectiveRef.error" class="form-control-feedback error-text col-sm-10">
              <div [hidden]="!ipDirectiveRef.error">
                <span style="color: red; font-weight: bold"> {{ ipDirectiveRef.errorMessage }} </span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group" *ngIf="application.appletcheckByPassIpaddress">
        <legend></legend>
        <label class="col-sm-7 col-form-label"
          style="max-width: 58%">{{validationMessages.EMAILS_V2020_UPPER_TEXT_WITH_S}}:<i
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" class="fa" aria-hidden="true"></i>
        </label>
        <div class="row" *ngIf="application.appletcheckByPassIpaddress">
          <div class="col-sm-7 has-error">
            <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='true'">
              <textarea class="form-control z-depth-1" [(ngModel)]="emailbyPassGroup" name="emailbypassGroupValid"
                #emailbypassGroupValid="ngModel" id="emailbypassGroup" rows="3"
                placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITHOUT_S_ADDRESSES}} separated by a comma. For example: {{validationMessages.MULTIPLE_EMAIL_V2020_EXAMPLE}}"
                style="margin-left:13px;" [disabled]="bypassIpAddress" MultiEmailValidationDirective
                #directiveRef3="MultiEmailValidationDirective"></textarea>
              <div *ngIf="directiveRef3.error" class="form-control-feedback error-text col-sm-10">
                <div [hidden]="!directiveRef3.error">
                  <span style="color: red; font-weight: bold"> {{ directiveRef3.errorMessage }} </span>
                </div>
              </div>
            </section>
            <section *ngIf="validationMessages.VALIDATE_SHOW_EMAIL_INPUT_FIELD_FOR_BYPASS=='false'">
              <textarea class="form-control z-depth-1" [(ngModel)]="emailbyPassGroup" name="emailbypassGroupValid"
                #emailbypassGroupValid="ngModel" id="emailbypassGroup" rows="3"
                placeholder="Enter {{validationMessages.EMAILS_V2020_LOWER_TEXT_WITHOUT_S_ADDRESSES}} separated by a comma. For example: {{validationMessages.MULTIPLE_EMAIL_V2020_EXAMPLE}}"
                style="margin-left:13px;" [disabled]="bypassIpAddress"></textarea>
            </section>
          </div>
        </div>

      </fieldset>

      <fieldset class="form-group" *ngIf="showOsByPass">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Allow
          older (unsupported) operating systems to login and bypass the
          authentication validation?<i style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
            title="{{allowBypassOsTitle}}" class="fa fa-question" aria-hidden="true"></i>
        </label>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Allow user to login if cyberscore does not meet
          threshold<i style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"
            title="{{allowFailureTitle}}" class="fa fa-question" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input style="margin-left: 20%" type="radio" [(ngModel)]="isFailureAllow" name="isFailureAllow"
              [value]="true" (click)="resetData()"> YES
            <input style="margin-left: 20%" type="radio" [(ngModel)]="isFailureAllow" name="isFailureAllow"
              [value]="false" (click)="clearData()" [checked]> NO
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Number of attempts allowed<i
            class="fa fa-question" aria-hidden="true" title="{{numberAttemptsAllowedTitle}}"
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.maxFailedRetriesAttempts" name="maxFailedRetriesAttempts" type="number"
              min="{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
              max="{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
              class="form-control field" id="numberAttemptsAllowed" (keyup)="validateMaxFailedRetriesAttempts()"
              #maxFailedRetriesAttempts="ngModel"
              [ngClass]="maxFailedRetriesAttempts.errors  ? 'has-danger':'has-success'" [disabled]="!isFailureAllow"
              required>
          </div>
          <div
            *ngIf="maxFailedRetriesAttempts.errors && (maxFailedRetriesAttempts.dirty || maxFailedRetriesAttempts.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!maxFailedRetriesAttempts.errors.required">
              <span style="color: red; font-weight: bold">Required</span>
            </div>
          </div>
          <div id="maxFailedRetriesAttemptsRangeErrorDiv" class="form-control-feedback error-text col-sm-5"
            [ngStyle]="{'display': 'none'}">
            <span style="color: red; font-weight: bold">Number of attempts must be between
              {{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}} to
              {{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}</span>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label label-width">Time period (days)<i class="fa fa-question"
            aria-hidden="true" title="{{timePeriodTitle}}"
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input [(ngModel)]="application.retriesFailedPeriod" name="retriesFailedPeriod" type="number"
              min="{{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
              max="{{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}}"
              class="form-control field" id="retriesFailedPeriod" (keyup)="validateRetriesFailedPeriod()"
              #retriesFailedPeriod="ngModel" [ngClass]="retriesFailedPeriod.errors  ? 'has-danger':'has-success'"
              [disabled]="!isFailureAllow" required>
          </div>
          <div *ngIf="retriesFailedPeriod.errors && (retriesFailedPeriod.dirty || retriesFailedPeriod.touched)"
            class="form-control-feedback error-text col-sm-5">
            <div [hidden]="!retriesFailedPeriod.errors.required">
              <span style="color: red; font-weight: bold">Required</span>
            </div>
          </div>
          <div id="retriesFailedPeriodRangeErrorDiv" class="form-control-feedback error-text col-sm-5"
            [ngStyle]="{'display': 'none'}">
            <span style="color: red; font-weight: bold">Time period must be between
              {{portalConfigValuesFromS3.MIN_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}} to
              {{portalConfigValuesFromS3.MAX_RETRIES_FAILED_PERIOD_AND_MAX_FAILED_RETRIES_ATTEMPTS}} days</span>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Enable remediation?
          <i class="fa fa-question" title={{enableRemediationTitle}}
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input style="margin-left: 20%" type="radio" [(ngModel)]="enableRemediation" name="enableRemediation"
              [value]="true"> YES
            <input style="margin-left: 20%" type="radio" [(ngModel)]="enableRemediation" name="enableRemediation"
              [value]="false" [checked]> NO
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group" >
        <legend></legend>
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> First time install: Allow User to authenticate
          after enrolling device?
          <i class="fa fa-question" title={{skipAppletCheckAfterInstallingTitle}}
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input style="margin-left: 20%" type="radio" [(ngModel)]="skipAppletCheckAfterInstalling"
              name="skipAppletCheckAfterInstalling" [value]="true"> YES
            <input style="margin-left: 20%" type="radio" [(ngModel)]="skipAppletCheckAfterInstalling"
              name="skipAppletCheckAfterInstalling" [value]="false" [checked]> NO
          </div>
        </div>
      </fieldset>


      <fieldset class="form-group">
        <div class="row">
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-12">
                <label class="col-sm-12 col-form-label" style="padding-right: 6px;"> Select the
                  additional user related
                  services you want to integrate below:
                  <i class="fa fa-question" title={{thirdPartyServiceString}}
                    style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
                </label>
              </div>
              <fieldset class="col-sm-12">
                <div class="col-sm-12">
                  <input style="margin-left: 2.7%" type="checkbox" [checked]="enablePhishing"
                    (click)="togglePhishingUI()" name="enablePhishing">
                  Phishing
                </div>
                <!--                <div class="col-sm-12">-->
                <!--                  <input style="margin-left: 2.7%;margin-top: 5%;" type="checkbox"-->
                <!--                         [checked]="enableSAT" (click)="toggleSatUI()" name="enableSAT"> SAT-->
                <!--                </div>-->
                <!--                <div *ngIf="!enablePhishing && !enableSAT"-->
                <!--                     class="form-control-feedback error-text col-sm-12">-->

              </fieldset>

            </div>
          </div>
        </div>
      </fieldset>
      <!-- <fieldset class="form-group" [ngStyle]="{'display': enableSAT  ? 'block' : 'none' }" >
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Training Survey Required for Training
          completion
          <i class="fa fa-question" title={{satCompulsaryToLoginInstr}}
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <fieldset>
              <input style="margin-left: 20%" type="radio" (click)="toggleMandatorySATForLogin(true)"
                [(ngModel)]="application.trainingSurveyRequiredForTrainingCompletion" name="mandatorySATForLogin"
                [value]="true"> YES
              <input style="margin-left: 20%" type="radio" (click)="toggleMandatorySATForLogin(false)"
                [(ngModel)]="application.trainingSurveyRequiredForTrainingCompletion" name="mandatorySATForLogin"
                [value]="false" [checked]>
              NO
            </fieldset>
          </div>
        </div>
      </fieldset> -->

      <!-- <fieldset class="form-group"
        [ngStyle]="{'display': (enableSAT && !application.trainingSurveyRequiredForTrainingCompletion) ? 'block' : 'none' }">
        <label class="col-sm-7 col-form-label" style="max-width: 58%;"> Number of time user is allowed in before
          having
          to take the exam
          <i class="fa fa-question" title={{satReminderAttemptCountString}}
            style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right" aria-hidden="true"></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <fieldset class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <input [(ngModel)]="application.numberAllowedLoginBeforeTakingExam" name="satReminderAttemptCount"
                    type="number" min="0" max="100" (blur)="validateSatReminderAttemptCountRange()"
                    (keyup)="validateSatReminderAttemptCountRange()" class="form-control field"
                    id="satReminderAttemptCount" #satReminderAttemptCount="ngModel"
                    [ngClass]="satReminderAttemptCount.errors  ? 'has-danger':'has-success'" >
                </div>
               <div *ngIf="satReminderAttemptCount.errors && (satReminderAttemptCount.dirty || satReminderAttemptCount.touched)"
			                                    class="form-control-feedback error-text col-sm-12">
			                                    <div [hidden]="!satReminderAttemptCount.errors.required">
			                                        <span style="color: red; font-weight: bold"> Reminder attempt number is
			                                            required</span>
			                                    </div>
			                                </div> 
                <div id="satReminderAttemptCountRangeErrorDiv" class="form-control-feedback error-text col-sm-12"
                  [ngStyle]="{'display': 'none'}">
                  <span style="color: red; font-weight: bold"> Reminder attempt number must be between
                    1 to
                    100</span>
                </div>
                <div id="satReminderAttemptCountEmptyErrorDiv" class="form-control-feedback error-text col-sm-12"
                  [ngStyle]="{'display': 'none'}">
                  <span style="color: red; font-weight: bold"> Reminder attempt number is
                    required</span>
                </div>
              </div>
            </fieldset>


          </div>
        </div>
      </fieldset> -->

      <fieldset class="form-group">
        <label class="col-sm-7 col-form-label label-width">
          Enable Help Button?
          <i
            class="fa fa-question"
            title="{{ enableHelpTitle }}"
            style="
              padding: 5px;
              padding-left: 7px;
              padding-right: 7px;
              float: right;
            "
            aria-hidden="true"
          ></i>
        </label>
        <div class="row">
          <div class="col-sm-7">
            <input
              style="margin-left: 20%"
              type="radio"
              [(ngModel)]="enableHelp"
              name="enableHelp"
              [value]="true"
              (click)="resetHelpButtonData()"
              [checked]="enableHelp === true"
            />
            YES
            <input
               style="margin-left: 20%"
               type="radio"
               [(ngModel)]="enableHelp"
               name="enableHelp"
               [value]="false"
               (click)="clearHelpButtonData()"
               [checked]="enableHelp === false"
            />
            NO
          </div>
        </div>
      </fieldset>

      <fieldset class="collapsible" id="helpButtonAttempt" [hidden]="!enableHelp">
        <fieldset class="form-group"  >
          <label class="col-sm-7 col-form-label label-width">
            Number of Help attempts allowed
            <i class="fa fa-question" aria-hidden="true"
               title="{{helpAttemptsAllowedTitle}}"
               style="padding: 5px; padding-left: 7px; padding-right: 7px; float: right"></i>
          </label>
          <div class="row">
            <div class="col-sm-7">
              <input [(ngModel)]="application.maxHelpButtonAttempt" name="maxHelpButtonAttempt"
                     type="number" min="0" max="999" class="form-control field" id="maxHelpButtonAttemptsAllowed"
                     (blur)="validateMaxHelpAttempts()" (keyup)="validateMaxHelpAttempts()"
                     #maxHelpButtonAttempt="ngModel"
                     [ngClass]="maxHelpButtonAttempt.errors  ? 'has-danger':'has-success'"
                     [readonly]="!enableHelp" required>
            </div>
            <div *ngIf="maxHelpButtonAttempt.errors && (maxHelpButtonAttempt.dirty || maxHelpButtonAttempt.touched)"
                 class="form-control-feedback error-text col-sm-5">
              <div [hidden]="!maxHelpButtonAttempt.errors.required">
                <span style="color: red; font-weight: bold">Required</span>
              </div>
            </div>
            <div id="maxHelpButtonAttemptRangeErrorDiv" class="form-control-feedback error-text col-sm-5"
                 [ngStyle]="{'display': 'none'}">
              <span style="color: red; font-weight: bold">Number of attempts must be between 1 to 999</span>
            </div>
          </div>
        </fieldset>
      </fieldset>

      <fieldset class="form-group row">
        <legend></legend>
        <div class="col-sm-5">
          <button type="submit" class="btn btn-primary"  style="margin-right: 0.5rem;"
            [disabled]="!registrationForm.form.valid || !isValidForm">Register</button>
          <button type="button" class="btn btn-primary" (click)="goBack()">Cancel</button>
        </div>
      </fieldset>
    </form>
  </div>
</div>
